export const baseUrl = 'systemadmin/metabase/reports'
export const cacheKey = 'reports'
export const apiVersion = '?api-version=1'
